<template>
    <b-avatar id="avatar-user" :size="size" variant="primary" :text="userInitials" :src="profilePreview || profilePicture" :class="avatarClass" style="z-index:1;">
    </b-avatar>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    size: {
      type: String,
      default: '2rem'
    },
    avatarClass: {
      type: String,
      default: ''
    },
    profilePreview: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('session', ['userInitials', 'profilePicture'])
  }
}
</script>

<style scoped>
.avatar-user-img{
  max-height: 100%;
}
</style>
